import React from 'react';
import classNames from 'classnames';

const Button = ({
  needsToLoad = false,
  title,
  icon,
  className: classNamesForButton = {},
  onClick,
  children,
}) => {
  const handleClick = event => !needsToLoad && onClick(event);
  const buttonClassNames = classNames({ loading: needsToLoad });

  const isDisabled = !!classNamesForButton.split(' ').find(res => res === 'disabled');
  const classNamesForButtonFiltered = classNamesForButton.split(' ').filter(res => res !== 'disabled').join(' ');
  return (
    <button className={buttonClassNames + ` ${classNamesForButtonFiltered}`} onClick={handleClick} disabled={isDisabled}>
      <span>{title}</span>
      {icon && <i className={icon} />}
      {needsToLoad && <div className="icon-spinner" />}
      {children}
    </button>
  );
};

export default Button;
